<section class="viewer" [ngClass]="{'editing-mode': editing == true}">
    <section class="editor" *ngIf="editing">
        <div class="form-group">
            <label>Filter</label>
            <input type="text" class="form-control dashboard-input" [(ngModel)]="filter">
        </div>
        <div class="form-group">
            <label>Aggregator</label>
            <input type="text" class="form-control dashboard-input" [(ngModel)]="aggregator">
        </div>

        <section class="events-pane-infos">
            <div class="first-column">
                <div class="form-group col-xs-12">
                    <label>Section</label>
                    <select class="form-control dashboard-input" [(ngModel)]="sectionFilter">
                        <option>None</option>
                        <option *ngFor="let section of uniqueSectionList">{{section}}</option>
                    </select>
                </div>
                <div class="form-group col-xs-12">
                    <label>Start Date</label>
                    <input type="text" class="form-control dashboard-input" [(ngModel)]="startDate">
                </div>
                <div class="form-group">
                    <label>Limit</label>
                    <input type="text" class="form-control dashboard-input" [(ngModel)]="limit">
                </div>
            </div>
            <div class="scd-column">
                <div class="form-group">
                    <label>Event</label>
                    <select class="form-control dashboard-input" [(ngModel)]="eventFilter">
                        <option>None</option>
                        <option *ngFor="let event of uniqueEventList">{{event}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>End Date</label>
                    <input type="text" class="form-control dashboard-input" [(ngModel)]="endDate">
                </div>
                <div class="form-group">
                    <label for="displayType">Display</label>
                    <select id="displayType" class="form-control dashboard-input" [(ngModel)]="displayType">
                        <option value="table">Table</option>
                        <option value="line-chart">Line Chart</option>
                        <option value="bar-chart">Bar Chart</option>
                        <option value="pie-chart">Pie Chart</option>
                        <option value="number">Number</option>
                    </select>
                </div>
            </div>
        </section>

        <input type="submit" class="btn btn-primary refresh-btn save-btn" (click)="save()" value="Save">
        <input type="submit" class="btn btn-primary refresh-btn delete-btn" (click)="delete()" value="Delete" *ngIf="_uid">

    </section>

    <ng-container class="events-edit-btn" *ngIf="!editing">
        <i class="fas fa-pen float-end" (click)="edit()"></i>
    </ng-container>

    <ng-container *ngIf="!editing && dataLoaded">
        <ng-container *ngIf="displayType=='table'">
            <div class="canvas-presentation" *ngIf="title">
                <div class="title">{{title}}</div>
                <p>{{subtitle}}</p>
            </div>
            <app-event-log-window [rows]="rows" [columns]="columns"></app-event-log-window>
        </ng-container>
        <ng-container *ngIf="displayType=='line-chart'">
            <div class="canvas-presentation" *ngIf="title">
                <div class="title">{{title}}</div>
                <p>{{subtitle}}</p>
            </div>
            <div class="canvas-container">
                <!-- <canvas baseChart [datasets]="lineChartDataSets" [labels]="pieLabels" [legend]="true"
                    [chartType]="lineChartType" [colors]="donutColors" width="75px" height="75px">
                </canvas> -->
            </div>
        </ng-container>
        <ng-container *ngIf="displayType=='bar-chart'">
            <div class="canvas-presentation" *ngIf="title">
                <div class="title">{{title}}</div>
                <p>{{subtitle}}</p>
            </div>
            <div class="canvas-container">
                <!-- <canvas baseChart [datasets]="lineChartDataSets" [labels]="pieLabels" [legend]="false"
                    [chartType]="barChartType" [colors]="donutColors" width="75px" height="75px">
                </canvas> -->
            </div>
        </ng-container>
        <ng-container *ngIf="displayType=='pie-chart'">
            <div class="canvas-presentation" *ngIf="title">
                <div class="title">{{title}}</div>
                <p>{{subtitle}}</p>
            </div>
            <div class="canvas-container">
                <!-- <canvas baseChart [data]="pieData" [labels]="pieLabels" [legend]="true" [chartType]="pieChartType"
                    [colors]="donutColors" width="75px" height="75px">
                </canvas> -->
            </div>
        </ng-container>
        <ng-container *ngIf="displayType=='number'">

        </ng-container>
    </ng-container>
    <ng-container class="loading" *ngIf="!editing && !dataLoaded">
        No Data
    </ng-container>
</section>
